module.exports = __webpack_public_path__ + "781b40cb08f1811fed66ebd801a9d9d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new-realisations/plaisirs-gastronomiques/03.jpg
// module id = pDzb
// module chunks = 0